export function showResults() {
    let parent = $(".faqs-wrapper");
    parent.find(".faqs-results").each(function (index, el) {
        let childElements = $(el).find(".accordion-item");
        let childElemenstCount = childElements.length;

        if (childElemenstCount > 5) {
            childElements.slice(5).hide();
            let restResult = childElemenstCount - 5;
            $(el).find(".button").text("show more (" + restResult + ")");
        } else {
            $(el).find(".button").hide();
        }

        $(el).find(".button").on("click", () => {
            childElements.slideDown(300);
            $(el).find(".button").hide();
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/showResults.js